import React from 'react';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null, errorInfo: null };
    }

    static getDerivedStateFromError(error) {
        // Update state so the next render will show the fallback UI.
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        // You can also log the error to an error reporting service
        console.error("Uncaught error:", error, errorInfo);
        this.setState({ error, errorInfo });
    }

    render() {
        if (this.state.hasError) {
            // You can render any custom fallback UI
            return (
                <div className="d-flex flex-column justify-content-center align-items-center vh-100 bg-dark text-white p-4">
                    <h1 className="display-4 text-warning mb-4">Something went wrong.</h1>
                    <p className="lead mb-4">We're sorry, but an unexpected error has occurred.</p>
                    <button
                        className="btn metro-btn-primary btn-lg fw-bold"
                        onClick={() => window.location.reload()}
                    >
                        Refresh Page
                    </button>
                    {process.env.NODE_ENV === 'development' && (
                        <details className="mt-4 p-3 border border-secondary rounded w-100" style={{ maxWidth: '800px', whiteSpace: 'pre-wrap' }}>
                            <summary className="text-warning cursor-pointer">Error Details</summary>
                            <div className="mt-2 text-danger">
                                {this.state.error && this.state.error.toString()}
                            </div>
                            <div className="mt-1 text-muted small">
                                {this.state.errorInfo && this.state.errorInfo.componentStack}
                            </div>
                        </details>
                    )}
                </div>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
